var ldbc = require('./doc-ldbc');
var jt = require('./doc-jt');
var pdf = require('./pdf');
// var lhqsz = require('./doc-lhqsz');
// var mjjd = require('./doc-mjjd');
const pdfjsLib = require("pdfjs-dist");
require("pdfjs-dist/web/pdf_viewer.css")
pdfjsLib.GlobalWorkerOptions.workerSrc = `../../static/pdf.worker.min.js`

module.exports = san.defineComponent({
    template: require('../views/intelligent-document-application.html'),
    initData: function () {
        return {
            pdfUrl: '',
            numPages: null,
            id: 1,
            open:false,
            showAlert: false,
            tipMessage: '',
            seedFail: true,//邮箱发送失败
            applicationType: 0,//0:模版下载;1:智能生成
            email: '',
            content:{
                id:'',
                templateUrl: '',
                templateContent:'',
                title:'',
                type:''
            },
            showLoading:false
        };
    },
    components: {
        'pdf':pdf,
        // 'mjjd': mjjd,
        'jt': jt,
        // 'lhqsz': lhqsz,
        'ldbc': ldbc
    },
    created: function() {
        this.data.set('content.templateContent','')

    },
    // 重置参数
    reset:function(){
        this.data.set('id','');
    },
     renderPage:function(page, container) {
      return new Promise((resolve) => {
        const viewport = page.getViewport({ scale: 1.5 });
        
        // 创建单页容器
        const pageDiv = document.createElement('div');
        pageDiv.className = 'pdf-page-container';
        pageDiv.style.marginBottom = '20px'; // 页间距
        
        // 创建Canvas
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        canvas.height = viewport.height;
        canvas.width = viewport.width;
        
        pageDiv.appendChild(canvas);
        container.appendChild(pageDiv);

        // 渲染页面内容
        page.render({
          canvasContext: ctx,
          viewport
        }).promise.then(resolve);
      });
    },
    getPdf:function(){
        const container = this.el.querySelector('#pdf-canvas')
        const url = this.data.get('pdfUrl')
        container.innerHTML = '';
        pdfjsLib.getDocument(url).promise
        .then(pdf => {
            const totalPages = pdf.numPages;
            const renderPromises = [];
            // 逐页创建渲染任务
            for (let pageNum = 1; pageNum <= totalPages; pageNum++) {
            renderPromises.push(
                pdf.getPage(pageNum)
                .then(page => this.renderPage(page, container))
                .catch(err => console.error(`第${pageNum}页渲染失败`, err))
            );
            }

            // 并行渲染所有页面
            return Promise.all(renderPromises);
        })
        .catch(error => {
            console.error("PDF加载失败:", error);
        })
    
        },
    // 获取文书ID
    getWsId:function(id){
        this.data.set('content.templateContent','')
        this.data.set('open',false);
        this.data.set('applicationType',0);
        this.data.set('id',id);
        var arr = [1,8];// 1,2,6,8
        if(arr.indexOf(id) > -1){
            this.data.set('open',true);
        }
        this.getWenshu();
        // this.dispatch('hide');
    },
    // 埋点
    modelSelect: function(t,id,name,c ) {
        var visitModel, visitModelName;
        switch (t) {
            case 1:
                visitModel = "SMART_WORD-HOUSE";
                visitModelName = "法律文书-房产买卖";
                break;
            case 2:
                visitModel = "SMART_WORD-MARRIAGE";
                visitModelName = "法律文书-婚姻家庭";
                break;
            case 3:
                visitModel = "SMART_WORD-TRAFFIC";
                visitModelName = "法律文书-交通事故";
                break;
            case 4:
                visitModel = "SMART_WORD-LABOR";
                visitModelName = "法律文书-劳动工伤";
                break;
            case 5:
                visitModel = "SMART_WORD-PRIVATE_LEND";
                visitModelName = "法律文书-民间借贷";
                break;
            case 6:
                visitModel = "SMART_WORD-CONTRACT";
                visitModelName = "法律文书-买卖合同";
                break;
            case 7:
                visitModel = "SMART_WORD-QYJY";
                visitModelName = "法律文书-企业经营";
                break;
            case 8:
                visitModel = "SMART_WORD-SSZC";
                visitModelName = "法律文书-诉讼仲裁";
                break;
            case 99:
                visitModel = "SMART_WORD-OTHER";
                visitModelName = "其它";
                break;
            case "":
                visitModel = "SMART_WORD-ALL";
                visitModelName = "法律文书-所有";
                break;
            default:
                visitModel = "SMART_WORD-ALL";
                visitModelName = "法律文书-所有";
                break;
        }
        window.NewLog._saveLog(visitModel, visitModelName, id, name, c);
    },
    hideLoad: function() {
        this.data.set('showLoading',false);
    },
    mail: function() {
        this.data.set('showAlert',true);
    },
    cancel: function() {
        this.data.set('showAlert',false);
    },
    // 发送邮箱
    modalSure: function() {
        var me = this;
        this.data.set('showFlag','1');
        if (this.data.get('email') == '') {
            this.data.set('tipMessage','邮箱不能为空');
            this.data.set('seedFail',true);
            return;
        }
        var reg = new RegExp("^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$");
        if (!reg.test(this.data.get('email'))) {
            this.data.set('tipMessage','邮箱格式不正确');
            this.data.set('seedFail',true);
            return;
        }
        this.cancel();
        this.data.set('showLoading',true);
        var data = {'remoteFile':me.data.get('content.templateUrl'),'toAddress': me.data.get('email')};
        Api("post", "/api/tintelligentwrit/v2/yitiji/sendMail", JSON.stringify(data)).then(function (response) {
            me.modelSelect(me.data.get('content.type'),me.data.get('content.id'),me.data.get('content.title'),"SEND_MAIL",me.data.get('email') );
            me.data.set('showLoading',false);
            if (response.code == 0) {
                me.dispatch('showAlert',{title:'提示',msg:"发送成功"});
            } else {
                me.dispatch('showAlert',{title:'提示',msg:response.msg});
            }
        });
    },
    // 生成二维码
    createQrcode: function(fileUrl) {
        // 动态生成二维码
        //47.97.195.1
        document.getElementById('qrcode').innerHTML='';
        window.qrcode = new QRCode('qrcode', {
            text: fileUrl,
            width: 160,
            height: 160
        });
        this.modelSelect(this.data.get('content.type'),this.data.get('content.id'),this.data.get('content.title'),"DOWNLOAD");
    },
    // 获取文书模板内容
    getWenshu: function() {
        var id = this.data.get('id');
        var me = this;
        Api("get", "/api/tintelligentwrit/v2/info?id=" + id).then(function (response) {
            const fileUrl = response.tIntelligentWrit.templateUrl
            me.data.set('content.id',response.tIntelligentWrit.id);
            me.data.set('content.templateContent',response.tIntelligentWrit.content);
            me.data.set('content.templateUrl',fileUrl);
            me.data.set('content.title',response.tIntelligentWrit.title);
            me.data.set('content.type',response.tIntelligentWrit.type);
            me.data.set('pdfUrl',response.tIntelligentWrit.pdfUrl);
            san.nextTick(function () {
                me.createQrcode(fileUrl)
                // me.getPdf()
            });
        });
    },
    // 文书下载
    wsxz: function(){
        this.data.set('applicationType',0);
    },
    // 智能生成
    znsc: function(){
        this.data.set('applicationType',1);
    },
    messages: {
        goScroll: function(top){
            window.ToScroll._scroll($('.traffic-content')[0],top.value);
            this.saveInfo(this.data.get("showFlag"),"CALCULATION");
        },
        goTo: function(top){
            $('.traffic-content')[0].scrollTop= $('.traffic-content')[0].scrollTop-top.value;
            this.data.set('backFlag', true);
            this.saveInfo(this.data.get("showFlag"),"CREATE_CONSULT_WORD");
        },
        createCort: function(data){
            this.data.set('listType', 2);
            this.data.set('backFlag', false);
            var me=this;
            san.nextTick(function () {
                me.ref('Accident2').getCort(data.value);
            });
        },
        goBack: function(){
            var flag=this.data.get('listType');
            if(flag==1){
                this.data.set('backFlag',false);
            }else{
                this.data.set('listType',1);
            }
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./src/components/intelligentDocumentApplication.js
// module id = 362
// module chunks = 1